import { render, staticRenderFns } from "./TizenVideoPlayer.vue?vue&type=template&id=52df0490&scoped=true&"
import script from "./TizenVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./TizenVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TizenVideoPlayer.vue?vue&type=style&index=0&id=52df0490&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52df0490",
  null
  
)

export default component.exports